export const columns = [
  { Header: "Data", accessor: "date", type: "date" },
  { Header: "Nome da Data", accessor: "name" },
  { Header: "Patrocinador pode Ver", accessor: "sponsor_can_see" },
  { Header: "Proponente pode Ver", accessor: "proponent_can_see" },
];
